import React from 'react'
import {useTranslation, Trans} from "react-i18next";
import {Info, Send} from "react-feather";

interface CreateCommentNeedsLoginProps {
  triggerLogin?: () => void
  displayMode?: 'modal' | 'inline'
}

export function CreateCommentNeedsLogin({triggerLogin, displayMode = 'modal'}: CreateCommentNeedsLoginProps) {
  const {t} = useTranslation('liveblog')

  return <div className={`tik4-create-comment ${displayMode === 'inline' ? 'tik4-create-comment--inline' : ''}`}>

  <button className="tik4-form-field tik4-form-field--sm tik4-comments__write__button" onClick={triggerLogin} disabled={!triggerLogin} type="button">
    <span className="tik4-comments__write__button__placeholder">{t('liveblog.comments.button.comment.generic')}</span>
    <Send className="tik4-icon tik4-comments__write__button__icon" />
  </button>

  <div className="tik4-hint tik4-hint--sm tik4-comments__write__hint">
    <Info className="tik4-icon" />
    <div className="tik4-hint__content">
      { triggerLogin ?
        <Trans i18nKey="liveblog.comments.login.with_button">
          {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
          Please <a href="#" className="tik4-link tik4-link--within-body" onClick={triggerLogin}>log in</a> to comment this message.
        </Trans>
        :
        t('liveblog.comments.login.no_button')
      }
    </div>
  </div>
</div>
}
